import { DiagnosisType } from "./diagnosis-type";

export class Vehicle {
  constructor(public id?: number,
              public trixUserId?: number,
              public userHashCode?: number,
              public plate?: string,
              public customerName?: string,
              public vehicleType?: any,
              public code?: string,
              public model?: string,
              public color?: string,
              public chassi?: string,
              public year?: string,
              public observation?: string,
              public coordinateStartDate?: Date,
              public diagnosisType?: DiagnosisType) { }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/vehicle.ts